import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useNewAdAccountRequestStore = defineStore({
  id: 'newAdAccountRequest',
  state: () => ({
    moderationComments: [],
  }),
  actions: {
    async getAllRequests(payload = {params: {}, signal: {}}) {
      const {signal, ...params} = payload

      const {data} = await axios.get('v1/companies/requests', {
        params,
        ...(signal && {signal}),
      })

      return data
    },
    async getRequestComments(payload) {
      const {data} = await axios.get('ad-account-requests/request-comments', {params: payload})

      return data
    },
    async setRequestModerationComments(comments) {
      this.moderationComments = comments
    },
    async getAdAccounts(params) {
      const {data} = await axios.get('ad-accounts', {params})

      return data
    },
  },
})
